import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'fc-footer-ui',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FooterComponent {}
